/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  GetRecurringPaymentApiV1RecurringPaymentGetQueryResponse,
  GetRecurringPaymentApiV1RecurringPaymentGetQueryParams,
  GetRecurringPaymentApiV1RecurringPaymentGetHeaderParams,
  GetRecurringPaymentApiV1RecurringPaymentGet422,
} from '../../types/GetRecurringPaymentApiV1RecurringPaymentGet.ts'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getRecurringPaymentApiV1RecurringPaymentGetQueryKey = (params?: GetRecurringPaymentApiV1RecurringPaymentGetQueryParams) =>
  [{ url: '/api/v1/recurring_payment' }, ...(params ? [params] : [])] as const

export type GetRecurringPaymentApiV1RecurringPaymentGetQueryKey = ReturnType<typeof getRecurringPaymentApiV1RecurringPaymentGetQueryKey>

/**
 * @summary Get Recurring Payment
 * {@link /api/v1/recurring_payment}
 */
export async function getRecurringPaymentApiV1RecurringPaymentGet(
  params?: GetRecurringPaymentApiV1RecurringPaymentGetQueryParams,
  headers?: GetRecurringPaymentApiV1RecurringPaymentGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetRecurringPaymentApiV1RecurringPaymentGetQueryResponse,
    ResponseErrorConfig<GetRecurringPaymentApiV1RecurringPaymentGet422>,
    unknown
  >({ method: 'GET', url: `/api/v1/recurring_payment`, params, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getRecurringPaymentApiV1RecurringPaymentGetQueryOptions(
  params?: GetRecurringPaymentApiV1RecurringPaymentGetQueryParams,
  headers?: GetRecurringPaymentApiV1RecurringPaymentGetHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getRecurringPaymentApiV1RecurringPaymentGetQueryKey(params)
  return queryOptions<
    GetRecurringPaymentApiV1RecurringPaymentGetQueryResponse,
    ResponseErrorConfig<GetRecurringPaymentApiV1RecurringPaymentGet422>,
    GetRecurringPaymentApiV1RecurringPaymentGetQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getRecurringPaymentApiV1RecurringPaymentGet(params, headers, config)
    },
  })
}

/**
 * @summary Get Recurring Payment
 * {@link /api/v1/recurring_payment}
 */
export function useGetRecurringPaymentApiV1RecurringPaymentGet<
  TData = GetRecurringPaymentApiV1RecurringPaymentGetQueryResponse,
  TQueryData = GetRecurringPaymentApiV1RecurringPaymentGetQueryResponse,
  TQueryKey extends QueryKey = GetRecurringPaymentApiV1RecurringPaymentGetQueryKey,
>(
  params?: GetRecurringPaymentApiV1RecurringPaymentGetQueryParams,
  headers?: GetRecurringPaymentApiV1RecurringPaymentGetHeaderParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetRecurringPaymentApiV1RecurringPaymentGetQueryResponse,
        ResponseErrorConfig<GetRecurringPaymentApiV1RecurringPaymentGet422>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getRecurringPaymentApiV1RecurringPaymentGetQueryKey(params)

  const query = useQuery(
    {
      ...getRecurringPaymentApiV1RecurringPaymentGetQueryOptions(params, headers, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetRecurringPaymentApiV1RecurringPaymentGet422>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}